import { $, $$, isMobile } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-accordion-section]')) return;

  isMobile.addEventListener('change', () => {
    addEventListeners();
    setStickyTopPosition();
  });

  setStickyTopPosition();
  addEventListeners();
}

/**
 *
 * Inside categories selector, when click on a category,
 * change text of selected one and scroll to top of module
 */
function addEventListeners() {
  $$('[data-au-accordion-section] [data-au-tab]').forEach((el) => {
    el.addEventListener('click', categoriesSelection);
  });

  $$('[data-au-accordion-section] [data-au-collapsable]').forEach((el) => {
    el.addEventListener('click', dataLayerAccordionCollapsables);
  });
}

function categoriesSelection(e) {
  const trigger = e.target,
    selectedCategory = trigger.querySelector('span:not([data-au-icon])').innerText,
    collapsable = trigger.closest('[data-au-collapsable-parent]').querySelector('[data-au-collapsable]'),
    collapsableContent = trigger.closest('[data-au-collapsable-content]'),
    collapsableIcon = collapsable.querySelector('[data-au-collapsable-icon]'),
    collapsableCategory = collapsable.querySelector('[data-au-collapsable-subtitle-text]');

  // close dropdown and change icon and aria-expanded attribute when select a category, on mobile
  if (isMobile.matches) {
    collapsableContent.classList.add('au-closed');
    collapsable.classList.add('au-closed');
    collapsable.setAttribute('aria-expanded', 'false');
    collapsableIcon.textContent = 'unfold_more';
  }

  // change text of selected category
  collapsableCategory.textContent = selectedCategory;

  // scroll top to see complete module
  if ($('[data-au-accordion-section]')) {
    $('[data-au-accordion-section]').scrollIntoView();
  }
}

function dataLayerAccordionCollapsables(e) {
  let clickText = e.target.querySelector(':not([data-au-icon])').innerText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  const action = e.target.getAttribute('aria-expanded') === 'false' ? 'contraer' : 'expandir',
    item_id = `${removeAccentMarkAndUppercase(clickText)}_${removeAccentMarkAndUppercase(action)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

/**
 *
 * Set top px of sticky. Is equal of header height + 16px of space if it exists.
 * If not, just those 16px on desktop and 0 on mobile.
 * FUNCTIONALITY TO REVIEW WHEN HAVE HEADER COMPONENT
 */
function setStickyTopPosition() {
  const stickyTop = isMobile.matches ? 0 : 16,
    header = $('header'),
    headerHeight = header ? parseInt(getComputedStyle(header).height, 10) + stickyTop : stickyTop;

  $$('[data-au-accordion-categories]').forEach((sticky) => {
    sticky.style.top = `${headerHeight}px`;
  });
}

export { categoriesSelection };
export default { init };
